const currencies = [
  {
    code: 'KHR',
    thousandFormat: ',',
    decimalDigits: 0,
    symbol: '៛',
    countryCode: 'KH',
  },
  {
    code: 'IDR',
    thousandFormat: '.',
    decimalDigits: 0,
    symbol: 'Rp',
    countryCode: 'ID',
  },
  {
    code: 'MYR',
    thousandFormat: ',',
    decimalFormat: '.',
    decimalDigits: 2,
    symbol: 'RM',
    countryCode: 'MY',
  },
  {
    code: 'MMK',
    thousandFormat: ',',
    decimalDigits: 0,
    symbol: 'K',
    countryCode: 'MM',
  },
  {
    code: 'PHP',
    thousandFormat: ',',
    decimalFormat: '.',
    decimalDigits: 2,
    symbol: '₱',
    countryCode: 'PH',
  },
  {
    code: 'SGD',
    thousandFormat: ',',
    decimalFormat: '.',
    decimalDigits: 2,
    symbol: 'S$',
    countryCode: 'SG',
  },
  {
    code: 'THB',
    thousandFormat: ',',
    decimalDigits: 0,
    symbol: '฿',
    countryCode: 'TH',
  },
  {
    code: 'VND',
    thousandFormat: '.',
    decimalDigits: 0,
    symbol: '₫',
    countryCode: 'VN',
  },
];

export default currencies;

export const CURRENCY_CODE = {
  Indonesia: 'IDR',
  Cambodia: 'KHR',
  Myanmar: 'MMK',
  Malaysia: 'MYR',
  Philippines: 'PHP',
  Singapore: 'SGD',
  Thailand: 'THB',
  Vietnam: 'VND',
};

const CountryCodeLookUpByCurrencyCode = Object.fromEntries(
  currencies.map(currency => [currency.code, currency.countryCode]),
);

export const getCountryCodeByCurrencyCode = currencyCode =>
  CountryCodeLookUpByCurrencyCode[currencyCode] || '';

export const getCurrencyByCurrencyCode = currencyCode =>
  currencies.find(c => c.code === currencyCode);
